export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_00.4e48e60f.jpg";